const date  = new Date();
const year = date.getFullYear();
const month = year+'-'+( '0'+(date.getMonth()+1)).slice(-2);

const ModelAides  =  {
  /*cheque Energie*/
  cheque_energie: {
    type: 'number',
    definition_period: month,
    isMontantAnnuel: true,
    entity: 'menage',
    imgSrc: 'logo_cheque_energie.png',
    link: 'https://www.aide-sociale.fr/cheque-energie/',
    link2 : '#link', label: 'Chèque Énergie'
  },
  /* Garantie jeunes*/
  garantie_jeunes: {
    type: 'number',
    definition_period: month,
    entity: 'individu',
    imgSrc: 'contrat-engaement-jeune-Logo-78.png', // logo
    link: 'https://www.aide-sociale.fr/contrat-engagement-jeune/',
    link2 : '#link', label: 'Contrat engagement jeune',
    floorAt: 1
  },

  /* Allocation familliale*/
  af: {
    type: 'number',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_caf.png',
    link: 'https://www.aide-sociale.fr/montant-allocation-familiale/',
    link2 : '#link', label: 'Allocation familliale',
    floorAt: 1
  },

  cf: {
    type: 'number',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_caf.png',
    link: 'https://www.aide-sociale.fr/allocations-familiales-3-enfants/',
    link2 : '#link', label: 'Complément familial',
    floorAt: 1
  },

  asf: {
    type: 'number',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_caf.png',
    link: 'https://www.aide-sociale.fr/allocation-soutien-familial/',
    link2 : '#link', label: 'Allocation de soutien familial (ASF)',
    floorAt: 1
  },

  rsa: {
    type: 'number',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_caf.png',
    link: 'https://www.aide-sociale.fr/rsa-socle-dossier-calcul/',
    link2 : '#link', label: 'Revenu de solidarité active (RSA) ',
    floorAt: 1
  },

  aah: {
    type: 'number',
    definition_period: month,
    entity: 'individu',
    imgSrc: 'logo_caf.png',
    link: 'https://www.aide-sociale.fr/aah-allocation-adulte-handicape/',
    link2 : '#link', label: 'Allocation aux adultes handicapés',
    floorAt: 1
  },

  caah: {
    type: 'number',
    definition_period: month,
    entity: 'individu',
    imgSrc: 'logo_caf.png',
    link: 'https://www.aide-sociale.fr/complement-aah-majoration-vie-autonome/',
    link2 : '#link', label: "Majoration Vie Autonome",
    floorAt: 1
  },

  asi: {
    type: 'number',
    definition_period: month,
    entity: 'individu',
    imgSrc: 'logo_assurance_maladie.png',
    link: 'https://www.aide-sociale.fr/asi-allocation-supplementaire-d-invalidite/',
    link2 : '#link', label: "Allocation supplémentaire d'invalidité",
    floorAt: 5
  },

  aide_logement: {
    type: 'number',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_caf.png',
    link: 'https://www.aide-sociale.fr/apl-caf/',
    link2 : '#link', label: 'Aides au logement',
    floorAt: 5
  },

  bourse_college: {
    type: 'number',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_education_nationale.png',
    link: 'https://www.aide-sociale.fr/bourse-des-colleges/',
    link2 : '#link', label: 'Bourse de collège',
    isMontantAnnuel: true
  },

  bourse_lycee: {
    type: 'number',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_education_nationale.png',
    link: 'https://www.aide-sociale.fr/bourse-de-lycee/',
    link2 : '#link', label: 'Montant annuel de la bourse de lycée',
    isMontantAnnuel: true
  },

  aspa: {
    type: 'number',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_assurance_retraite.png',
    link: 'https://www.aide-sociale.fr/minimum-retraite-aspa/',
    link2 : '#link', label: 'Allocation de solidarité aux personnes agées',
    floorAt: 1
  },

  ass: {
    // Aide pole emploi
    type: 'number',
    definition_period: month,

    entity: 'individu',
    imgSrc: 'logo-france-travail-simulateur-45.png',
    link: 'https://www.aide-sociale.fr/ass-allocation-solidarite-specifique/',
    link2 : '#link', 
    label: "Allocation de solidarité spécifique (ASS)",
    floorAt: 10
  },

  apa_eligibilite: {
    type: 'boolean',
    definition_period: month,
    entity: 'individu',
    imgSrc: "logo_cd_generique.png",
    link: 'https://www.aide-sociale.fr/allocation-personnalisee-autonomie/',
    link2 : '#link', label: "Allocation personalisée d'autonomie",
    floorAt: 1
  },

  livret_epargne_populaire_taux: {
    type: 'number',
    definition_period: month,
    unit: '%',
    entity: 'individu',
    imgSrc: 'logo_banque_de_france.png',
    link: 'https://www.aide-sociale.fr/livret-epargne-populaire/',
    link2 : '#link', label: "livret d'épargne populaire",
    suffix: 'au lieu de 0,75%'
  },

  ppa: {
    type: 'number',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_caf.png',
    link2 : '#link', label: "Prime d'Activité",
    link: 'https://www.aide-sociale.fr/calcul-prime-activite-demande/',
    floorAt: 5
  },

  paje_base: {
    type: 'number',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_caf.png',
    link: 'https://www.aide-sociale.fr/allocation-base-caf/',
    link2 : '#link', label: 'Prestation d’accueil du jeune enfant – Allocation de base',
    floorAt: 1
  },

  css_participation_forfaitaire: {
    type: 'number', // type complex css
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_assurance_maladie.png',
    link: 'https://www.aide-sociale.fr/complementaire-sante-solidaire/',
    link2 : '#link', label: 'Complémentaire santé solidaire'
  },

  cmu_c: {
    // loi 1er novembre 2019  cmu_c  --> ASS
    type: 'boolean',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_assurance_maladie.png',
    link: 'https://www.aide-sociale.fr/complementaire-sante-solidaire/',
    link2 : '#link', label: 'Complémentaire santé solidaire'
  },

  logement_social_eligible: {
    type: 'boolean',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_ministere_cohesion_territoires.png',
    link: 'https://www.aide-sociale.fr/faire-demande-de-logement-social/',
    link2 : '#link', label: 'Eligible au Logement social'
  },

  rennes_metropole_transport: {
    type: 'number',
    definition_period: month,
    entity: 'individu',
    link2 : '#link', label: 'Tarification solidaire transports',
    unit: '%',
    imgSrc: 'logo_rennes_metropole.png',
    link: 'http://metropole.rennes.fr/pratique/infos-demarches/deplacements-stationnement-voirie/tarification-solidaire-des-transports/'
  },
  brest_metropole_transport: {
    link2 : '#link', label: 'Tarification solidaire transports',
    definition_period: month,
    entity: 'individu',
    type: 'number',
    imgSrc: 'logo_brest_metropole.png',
    link: 'https://www.bibus.fr/fr/titres-tarifs/titres/forfait-solidaire-mensuel-tempo/'
  },

  alfortville_noel_enfants: {
    link2 : '#link', label: 'Noël des enfants',
    definition_period: month,
    type: 'boolean',
    entity: 'famille',
    imgSrc: 'logo_alfortville.png',
    link: 'https://www.alfortville.fr/le-pole-solidarite-insertion#Noel-des-enfants',
    isMontantAnnuel: true
  },

  cotes_d_armor_fonds_solidarite_logement_energie_eligibilite: {
    link2 : '#link', label: 'Fonds de solidarité pour le logement - Aide au paiement des factures d’énergie',
    definition_period: month,
    entity: 'individu',
    type: 'boolean',
    imgSrc: 'logo_cd22.png',
    link: 'https://cotesdarmor.fr/vos-services/acceder-ou-se-maintenir-dans-son-logement',
    isMontantAnnuel: true
  }
};


const setupCalculsDroits = ()=>{
	const droits = Object.keys(ModelAides);
	var data = {};
	droits.forEach( (droit)=> {
		data[droit.entity] = null;
	})
	return ;
}

const getDroitsAvailable = (entities , definedRessources= [])=>{
	const droits = Object.keys(ModelAides);
	var droitsBeneficiable = [];
	droits.forEach((droit)=>{
		const model = ModelAides[droit];
		var data;
		if ( model.entity === 'famille'  && ![undefined,null].includes(entities.familles)) {
			data = entities.familles._[droit];
		}
		else if ( model.entity === 'foyer_fiscal' && ![undefined,null].includes(entities.foyers_fiscaux)) {
			data = entities.foyers_fiscaux._[droit];
		}
		else if ( model.entity === 'individu' && ![undefined,null].includes(entities.individus)) {
			data = entities.individus.individu[droit];
		}
		else if ( model.entity === 'menage' && ![undefined,null].includes(entities.menages)) {
			data = entities.menages._[droit];
		}
		if (data !== undefined) {
			var value = data[model.definition_period] ;
      
      if ( droit === "aide_logement" && value  > 100){
        //value = Math.round( 0.996047*value+16.6008);
      }
			
      if (  value > 0 && !(
          (model.floorAt !== undefined && value < model.floorAt) )
           
        ) {
        model.nom = droit;
        var addDroit = true;
        
        var nonChequeEnergie = entities.individus.individu.enfant_a_charge == true;

        if (droit === 'cheque_energie' && nonChequeEnergie ) {
          addDroit = false;
        }
        

        if ( !definedRessources.includes(model.nom) && addDroit){
				  droitsBeneficiable.push ( { ...model , ...{'value':value} });
        }
			}
		}

	});

	return droitsBeneficiable;
}

const traitementAidesCategories = (aides)=> {
	var droitsBeneficiable = {};
  for ( let categorie in aides) {
    droitsBeneficiable[categorie] = aides[categorie].map((droit)=>(
      {
        link2 : droit.link2, label: droit.nom,
        type: typeof droit.montant,
        value: droit.montant,
        imgSrc: droit.image,
        link: droit.link,
        indication : droit.indication,
      }
    ));
  }

	return droitsBeneficiable;
}

export {ModelAides , getDroitsAvailable , traitementAidesCategories, setupCalculsDroits};